import c from "./_Symbol.js";
var a = c, e = Object.prototype, f = e.hasOwnProperty, s = e.toString, r = a ? a.toStringTag : void 0;
function y(t) {
  var o = f.call(t, r), n = t[r];
  try {
    t[r] = void 0;
    var i = !0;
  } catch {
  }
  var g = s.call(t);
  return i && (o ? t[r] = n : delete t[r]), g;
}
var S = y;
export {
  S as default
};
//# sourceMappingURL=_getRawTag.js.map
